module.exports = __webpack_public_path__ + "img/Smartwatch.633f3c3b.svg";